import React from 'react';
import { motion } from 'framer-motion';
import educationData from '../data/education.json';

const Education = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="py-16"
    >
      <h2 className="section-heading">Education</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {educationData.education.map((edu, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className={`bg-card p-6 rounded-lg shadow-md ${!edu.details ? 'flex items-center' : ''}`}
          >
            <div className={`flex flex-col items-center text-center ${!edu.details ? 'w-full' : ''}`}>
              <div className="w-24 h-24 mb-4">
                <img
                  src={edu.logo}
                  alt={`${edu.school} logo`}
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-semibold mb-2">{edu.school}</h3>
              <p className="text-muted-foreground mb-1">{edu.location}</p>
              <p className="text-muted-foreground mb-2">{edu.degree}</p>
              {edu.track && (
                <p className="text-muted-foreground mb-2">{edu.track}</p>
              )}
              <p className="text-sm text-muted-foreground mb-4">{edu.period}</p>
              
              {edu.details && (
                <div className="w-full text-left space-y-3 mt-2">
                  {edu.details.map((detail, idx) => (
                    <div key={idx} className="border-t border-gray-200 pt-3">
                      <h4 className="font-medium text-primary">{detail.phase}</h4>
                      {detail.name && (
                        <p className="text-muted-foreground">{detail.name}</p>
                      )}
                      <p className="text-sm text-muted-foreground">{detail.status}</p>
                      <p className="text-sm text-muted-foreground">{detail.grade}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default Education;
